import styled from 'styled-components';

const LeaderboardsList = styled.section`
  margin-top: 14px;

  @media screen and (min-width: 650px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: 850px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (min-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export default LeaderboardsList;
